import { INITIALIZE_AUTH } from '../actions/ActionTypes';
const initialState = {
  gates: [],
  user: {},
  portal: {},
  scopes: []
};
const auth = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_AUTH:
      return {
        user: action.user,
        gates: action.gates,
        portal: action.portal,
        scopes: action.user.scopes
      };
    default:
      return state;
  }
};
export default auth;